import {computed, DestroyRef, Injectable, signal, Signal, WritableSignal} from '@angular/core';

@Injectable({providedIn: 'root'})
export class LoadingService {
  tasks: WritableSignal<Signal<boolean>[]> = signal([]);
  globalLoading = computed(() => this.tasks().some(task => task()));

  createLoading(destroyRef: DestroyRef) {
    const loading = signal(false);
    const index = this.addTask(loading);
    destroyRef.onDestroy(() => this.removeTask(index));
    return loading;
  }

  addLoading(loading: Signal<boolean>, destroyRef: DestroyRef) {
    const index = this.addTask(loading);
    destroyRef.onDestroy(() => this.removeTask(index));
    return loading;
  }

  private addTask(loading: Signal<boolean>): number {
    this.tasks.update(tasks => [...tasks, loading]);
    return this.tasks().length - 1;
  }

  private removeTask(index: number) {
    this.tasks.update(tasks => {
      tasks.splice(index, 1);
      return [...tasks];
    });
  }
}
